import React from "react";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    icon: {
        width: 34,
        marginRight: 5,
        marginTop: 5
    }
});

export default function Bonus() {
    const classes = useStyles();
    return <img src="/assets/images/new_icons/bonus.svg" className={classes.icon} alt="Bonus" />
}
